module.exports = __webpack_public_path__ + "img/join-code.36a76407.png";